import React from 'react'
import { Switch } from 'react-router-dom'
import Route from './Route'

import SignIn from '../pages/SignIn'
import SignUp from '../pages/SignUp'
import PassRecoverGetCRM from '../pages/PassRecover/GetCRM'
import PassRecoverPasswordChange from '../pages/PassRecover/PasswordChange'
import NotAllowed from '../pages/NotAllowed'
import Dashboard from '../pages/UserViews/Dashboard'
import DashboardEmpresa from '../pages/UserViews/DashboardEmpresa'
import GrupoPermissoes from '../pages/UserViews/GrupoPermissoes'
import Perfil from '../pages/UserViews/Perfil'
import DadosCadastrais from '../pages/UserViews/EspacoMedico/DadosCadastrais'
import Checkout from '../pages/UserViews/Pagamento'
import Gerenciamento from '../pages/UserViews/Gerenciamento'
import Logs from '../pages/UserViews/Log'
import DashboardProntuario from '../pages/UserViews/Dashboard/Prontuario'
import ComercialProdutos from '../pages/ComercialProdutos'
import ComercialModulo from '../pages/ComercialProdutos/Modulo'
import UsuarioConfirmacao from '../pages/UsuarioConfirmacao/index'
import MembroFamiliaConsentimento from '../pages/MembroFamiliaConsentimento'
import DashboardProntuarioTag from '../pages/UserViews/Dashboard/Prontuario/Tag'
import DadosEmergencia from '../pages/DadosEmergencia'
import LandingPage from '../pages/LandingPage'
import ConfirmacaoAlteracaoAcesso from '../pages/ConfirmacaoAlteracaoAcesso'
import DadosEmergenciaCompartilhado from '../pages/DadosEmergenciaCompartilhado'
import QuemSomos from '../pages/QuemSomos'
import Contatos from '../pages/Contatos'
import PoliticaPrivacidade from '../pages/PoliticaPrivacidade'
import PoliticaReembolso from '../pages/PoliticaReembolso'
import TermosDeUso from '../pages/TermosDeUso'
import Assinaturas from '../pages/UserViews/Assinaturas'
import FormasPagamento from '../pages/UserViews/FormasPagamento'
import Familia from '../pages/UserViews/Familia'
import ComercialProntuario from '../pages/Comercial/ProntuarioMedico'
import EmergenciaAcessos from '../pages/UserViews/EmergenciaAcessos'
import AdministracaoAssinaturas from '../pages/UserViews/Admin/Assinaturas'
import AdministracaoFaturas from '../pages/UserViews/Admin/Faturas'
import AdministracaoGratuidades from '../pages/UserViews/Admin/Gratuidades'
import AdministracaoParceiros from '../pages/UserViews/Admin/Parceiros'
import AdministracaoBeneficiarios from '../pages/UserViews/Admin/Beneficiarios'
import AdministracaoParceirosCarga from '../pages/UserViews/Admin/Parceiros/CargaUsuarios'
import AdministracaoParceirosAdmins from '../pages/UserViews/Admin/Parceiros/Admins'
import DashboardAdmin from '../pages/UserViews/Admin/Dashboard'
import ProntuarioMembro from '../pages/UserViews/ProntuarioMembro'
import UpgradePlano from '../pages/UserViews/UpgradePlano'
import Acesso from '../pages/UserViews/Acesso'
import DecisaoLogin from '../pages/DecisaoLogin'
import AlterarPlano from '../pages/UserViews/Assinaturas/AlterarPlano'
import Agenda from '../pages/UserViews/Agenda'
import Evento from '../pages/UserViews/Agenda/Evento'
import ConfirmacaoConta from '../pages/ConfirmationAccountOTP'
import AdministracaoAcessos from '../pages/UserViews/Admin/Acessos'
import ContratacaoGratis from '../pages/ContratacaoGratis'
import AddToCart from '../pages/AddToCart'

export default function Routes() {
    return (
        <Switch>
            <Route path="/" exact component={ComercialProdutos} />
            <Route path="/login" exact component={SignIn} />
            <Route path="/confirmacao_conta" exact component={ConfirmacaoConta} />

            <Route path="/signup" component={SignUp} />
            <Route path="/pass_recover" exact component={PassRecoverGetCRM} />
            <Route path="/pass_recover/:token" component={PassRecoverPasswordChange} />

            <Route path="/quem-somos" component={QuemSomos} />
            <Route path="/contatos" component={Contatos} />
            <Route path="/termos-de-uso" component={TermosDeUso} />
            <Route path="/politica-privacidade" component={PoliticaPrivacidade} />
            <Route path="/politica-reembolso" component={PoliticaReembolso} />

            <Route path="/quem-somos" component={QuemSomos} isPrivate />
            <Route path="/contatos" component={Contatos} isPrivate />
            <Route path="/termos-de-uso" component={TermosDeUso} isPrivate />
            <Route path="/politica-privacidade" component={PoliticaPrivacidade} isPrivate />
            <Route path="/politica-reembolso" component={PoliticaReembolso} isPrivate />

            <Route path="/usuario/confirmacao/:token" component={UsuarioConfirmacao} />
            <Route path="/membro_familia/consentimento/:token" component={MembroFamiliaConsentimento} />
            <Route path="/auth/membro_familia/consentimento/:token" component={MembroFamiliaConsentimento} isPrivate />

            <Route path="/produtos/prontuario" exact component={LandingPage} />
            <Route path="/produtos/prontuario/comercial" exact component={ComercialProntuario} />
            <Route path="/auth/produtos/prontuario" component={LandingPage} isPrivate />
            <Route path="/auth/produtos" component={ComercialProdutos} isPrivate />

            <Route path="/feature/:id" component={ComercialModulo} />
            <Route path="/auth/feature/:id" component={ComercialModulo} isPrivate />

            <Route path="/auth/checkout" component={Checkout} isPrivate />

            <Route path="/not_allowed" component={NotAllowed} isPrivate />

            <Route path="/dashboard" component={Dashboard} isPrivate exact />
            <Route path="/dashboard_empresa" component={DashboardEmpresa} isPrivate />
            <Route path="/perfil" component={Perfil} isPrivate />
            <Route path="/acesso" component={Acesso} isPrivate />
            <Route path="/grupo_permissoes/:grupoId" component={GrupoPermissoes} isPrivate />

            <Route path="/dados_cadastrais" component={DadosCadastrais} isPrivate />

            <Route path="/gerenciar/:entidade" component={Gerenciamento} isPrivate />

            <Route path="/logs" component={Logs} isPrivate />

            <Route path="/dashboard/prontuario" exact component={DashboardProntuario} isPrivate />
            <Route path="/dashboard/prontuario/tag/:pessoa_id" component={DashboardProntuarioTag} isPrivate />

            <Route path="/emergencia/acessos" component={EmergenciaAcessos} exact isPrivate />
            <Route path="/emergencia/:token" component={DadosEmergencia} exact />

            <Route path="/emergencia/:token/shared/:qrcode_token" component={DadosEmergenciaCompartilhado} />

            <Route path="/usuario/email_alteracao/confirmacao/:token" component={ConfirmacaoAlteracaoAcesso} />

            <Route path="/assinaturas" component={Assinaturas} exact isPrivate />
            <Route path="/assinaturas/alterar_plano" component={AlterarPlano} isPrivate />
            <Route path="/formas-pagamento" component={FormasPagamento} isPrivate />

            <Route path="/familia" component={Familia} isPrivate />

            <Route path="/admin" exact component={DashboardAdmin} isPrivate />
            <Route path="/admin/assinaturas" component={AdministracaoAssinaturas} isPrivate />
            <Route path="/admin/faturas" component={AdministracaoFaturas} isPrivate />
            <Route path="/admin/acessos" component={AdministracaoAcessos} isPrivate />
            <Route path="/admin/gratuidades" component={AdministracaoGratuidades} isPrivate />
            <Route path="/admin/parceiros" component={AdministracaoParceiros} isPrivate exact />
            <Route path="/admin/beneficiarios" component={AdministracaoBeneficiarios} isPrivate exact />
            <Route path="/admin/parceiros/:id/carga_usuarios" component={AdministracaoParceirosCarga} isPrivate />
            <Route path="/admin/parceiros/:id/admins" component={AdministracaoParceirosAdmins} isPrivate />

            <Route path="/prontuario/membro" component={ProntuarioMembro} isPrivate />

            <Route path="/plano/upgrade/:plano_atual/:plano_sugerido" component={UpgradePlano} isPrivate />

            <Route path="/choice" component={DecisaoLogin} />

            <Route path="/agenda" component={Agenda} isPrivate exact />
            <Route path="/agenda/evento/:id" component={Evento} isPrivate />

            <Route path="/contratacao/gratis/:id" component={ContratacaoGratis} isPrivate />

            <Route path="/plano/:id" component={AddToCart} />

            <Route path="*" />
        </Switch>
    )
}
